<template>
    <div class="grid col-4 col-gap-2 sm-col-2 row-gap-1">
        <a :href="'/profile/' + user.username" v-for="user in filtered_items" :key="user.id" class="hover:tw-opacity-75 tw-mb-2">
            <div class="card card-shadow user-result tw-mb-0 tw-h-full">
                <div class="card-top top-image">
                    <img :src="user.avatar">
                </div>
                <div class="card-inner">
                    <span class="tw-text-gray-300 tw-text-xs tw-break-all">
                        {{ user.username }}
                    </span>
                    <p class="tw-text-gray-700 tw-font-semibold tw-mt-1 tw-text-base tw-break-all">{{ user.firstname }} {{ user.lastname }}</p>
                    <span class="tw-text-gray-500 tw-text-xs tw-block tw-mt-2 tw-text-sm tw-break-all" v-if="user.profile !== null">{{ user.profile.company }}</span>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'SearchUser',

        props: {
            items: {
                required: true,
            },
            extended: {
                required: true,
                default: false,
            }
        },

        computed: {
            filtered_items() {
                if(this.extended) {
                    return this.items;
                }

                return this.items.slice(0, 4);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tw-text-gray-700 {
        color: #4a5568 !important;
    }

    .card {
        @apply tw-rounded-none tw-overflow-hidden tw-mb-0 #{!important};

        &.card-shadow {
            @apply tw-shadow #{!important};
        }
    }
</style>